<template>
  <div class="d-flex instance align-items-center border-radius">
    <div class="col">
      <h4 class="mb-0">{{ instance.name }}</h4>
      <div class="exportprofile" v-if="instance.type === 'assembly' && instance.hasExportProfile"><icon type="filter" />Exportprofile</div>
    </div>
    <div v-if="showDetails" class="col lighter smaller">
      {{ instance.id }}
      <div>Asset: {{ instance.asset && instance.asset.name ? instance.asset.name : 'loading' }} ({{ instance.asset ? instance.asset.id : '' }})</div>
    </div>
    <div v-if="!showTeamAttacher" :class="['col align-items-center']">
      <div class="form-error p-3" v-if="!assetIsGlobal && !allTeamsIncluded">
        {{ $t('projectInstanceMissingTeam') }}
      </div>
      <tag
          v-for="team in instance.asset.teams"
          :key="team.id"
          :name="team.displayName"
          icon-left="users"
          :tag="team"
          :organization-id="team.organizationId"
          :is-removable="false"
          class="me-1"
      />
      <div v-if="!assetIsGlobal && missingTeams.length">
        <div class="w-100" />
        {{ $t('missingTeams') }}:<br />
        <div class="lighter">{{ $t('clickToAddTeam') }}</div>
        <tag v-for="team in missingTeams"
             :key="team.id"
             :tag="{...team, color: '#c7590b'}"
             :is-removable="false"
             :is-addable="true"
             :icon-left="null"
             class="me-1 tag-missing lighter"
             @addTag="addTeam"
        />
      </div>
      <div
          v-if="!showTeamAttacher"
          @click="showTeamAttacher = true"
          class="lighter clickable float-right">
        {{ $t('editTeams') }} <icon type="edit" />
      </div>
    </div>
    <div v-if="showTeamAttacher" class="col">
      <team-attacher
          v-if="instance.asset && instance.asset.id"
          :id="instance.asset.id"
          :limit-by-organization-id="instance.asset.organizationId"
          :teams="instance.asset.teams"
          :show-as-info-panel="false"
          class="mt-1"
          store-name="Asset"
          @added="loadAssetTeams(instance.asset.id)"
          @removed="loadAssetTeams(instance.asset.id)"
      />
      <div
          @click="showTeamAttacher = false"
          class="lighter clickable float-right">
        {{ $t('abort') }} <icon type="xmark" />
      </div>
    </div>
  </div>
</template>

<script>
import TeamAttacher from "@/components/organizations/TeamAttacher.vue";
import Tag from "@/components/Tag.vue";
import Icon from "@/components/Icon.vue";
export default {
  name: "ProjectInstance",
  components: {TeamAttacher, Tag, Icon},
  props: {
    instance: {type: Object, required: true},
    showDetails: {type: Boolean, default: false},
    projectTeams: {type: Array, required: true},
  },
  data() {
    return {
      forceReRenderKey: 0,
      showTeamAttacher: false
    };
  },
  computed: {
    assetIsGlobal() {
      return this.$store.getters.isSuperOrg(this.assetOrganizationId);
    },
    assetOrganizationId() {
      return this.instance.asset.organizationId;
    },
    projectTeamsIds() {
      return this.projectTeams ? this.projectTeams.map(t => t.id) : [];
    },
    missingTeams() {
      const missing = [];
      for(let i = 0; i < this.projectTeams.length; i++) {
        const {id, displayName, name} = this.projectTeams[i];
        const found = this.instance.asset.teams.find(t => t.id === id);
        if (!found) {
          missing.push({id, displayName, name});
        }
      }
      return missing;
    },
    allTeamsIncluded() {
      for(let i = 0; i < this.projectTeamsIds.length; i++) {
        const teamId = this.projectTeamsIds[i];
        const found = this.instance.asset.teams.find(t => t.id === teamId);
        if (!found) {
          return false;
        }
      }
      return true;
    }
  },
  methods: {
    addTeam(team) {
      console.log('adding team')
      this.$store.dispatch("clientAddAssetResource", {
        id: this.instance.asset.id,
        params: [team.id]
      }).then(() => {
        this.loadAssetTeams(this.instance.asset.id);
      });
    },
    loadAssetTeams(assetId) {
      this.$store.dispatch("clientLoadAssetTeams", {
        id: assetId
      }).then((data) => {
        this.instance.asset.teams = data;
        this.showTeamAttacher = false;
        this.forceReRenderKey++;
      });
    }
  }
}
</script>


<style lang="scss" scoped>
.instance {
  padding: 10px 0;
  background-color: var(--vform-editor-ui-secondary-color);
}
.smaller {
  font-size: 0.8rem;
}
.exportprofile {
  margin-top: 5px;
  background-color: var(--vform-editor-ui-tertiary-color);
  color: #444;
  display: inline-block;
  font-size: 0.8rem;
  border-radius: 6px;
  padding: 2px 5px;
}
</style>